/**
 * @generated SignedSource<<f0a9478a723942cf36c5e60e64982ad8>>
 * @relayHash 9459c0218f4aabda777b263e43d6af57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainVirtualAgentSidebarQuery$variables = {
  checkForAiEnabledFF: boolean;
  cloudId: string;
  key: string;
};
export type mainVirtualAgentSidebarQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly virtualAgentConfiguration: {
        readonly __typename: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly " $fragmentSpreads": FragmentRefs<"nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav">;
    } | null | undefined;
  } | null | undefined;
};
export type mainVirtualAgentSidebarQuery = {
  response: mainVirtualAgentSidebarQuery$data;
  variables: mainVirtualAgentSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkForAiEnabledFF"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainVirtualAgentSidebarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "checkForAiEnabledFF",
                    "variableName": "checkForAiEnabledFF"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainVirtualAgentSidebarQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "VirtualAgentQueryError"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isVirtualAgentAvailable"
              },
              {
                "condition": "checkForAiEnabledFF",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAiEnabledInAdminHub"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda",
    "metadata": {},
    "name": "mainVirtualAgentSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ce0647263636d90a60ad14fa8f8cecad";

export default node;
